Ext.define('SA.view.Radio', {
    alias: 'widget.sa-radio',
    extend: 'SA.view.CheckField',

    ariaRole: 'radio',
    baseCls: 'sa-radio',

    deselect() {
        this.setSelected(false);
    },

    onLabelClick() {
        this.setChecked(true);
    },

    setSelected(selected) {
        this.setCheckedSuppressed(selected);
    }
});
